import React from 'react';

import { WebviewUnicornsGhosts } from './unicorns/webview-unicorns-ghosts';

export interface IWebViewWidgetProps {
  url: { locale: string };
  name?: string;
}

const WebViewWidget: React.FC<IWebViewWidgetProps> = ({ url, name }) => {
  /**
   *  There are interactive web views like unicornsGhosts. [vendor-gameName]
   *  Every interactive webview should have their own logic. Using this switch to return
   *  the specific component.
   */
  switch (name) {
    case 'unicornsGhosts':
      return <WebviewUnicornsGhosts url={url.locale} />;
    default:
      return (
        <iframe
          title="webview-widget"
          data-testid="webview-widget"
          src={url.locale}
          frameBorder="0"
          width="100%"
          height="100%"
        />
      );
  }
};

export default WebViewWidget;
